$(function() { 
    var pricingButton = $('.banner__toggle-button');
    var toggle = $('.banner__toggle');

    pricingButton.on('click', function() {
        toggle.toggleClass('banner__toggle--monthly');
    });
});